import styled from "styled-components";

export const Header = styled.header`
  font-family: "Heebo", sans-serif;
  background-color: #fafafa;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='250' height='30' viewBox='0 0 1000 120'%3E%3Cg fill='none' stroke='%23f5f5f5' stroke-width='24.9' %3E%3Cpath d='M-500 75c0 0 125-30 250-30S0 75 0 75s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3Cpath d='M-500 45c0 0 125-30 250-30S0 45 0 45s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3Cpath d='M-500 105c0 0 125-30 250-30S0 105 0 105s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3Cpath d='M-500 15c0 0 125-30 250-30S0 15 0 15s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3Cpath d='M-500-15c0 0 125-30 250-30S0-15 0-15s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3Cpath d='M-500 135c0 0 125-30 250-30S0 135 0 135s125 30 250 30s250-30 250-30s125-30 250-30s250 30 250 30s125 30 250 30s250-30 250-30'/%3E%3C/g%3E%3C/svg%3E");
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 100px 50px;
  text-align: center;
  @media screen and (max-width: 768px) {
    padding: 60px 15px;
  }
  :before {
    content: "";
    background-color: #1877f2;
    position: absolute;
    top: 0px;
    height: 10px;
    width: 100%;
    margin: 0px auto;
    padding: 0px;
  }
  h1 {
    font-weight: 100;
    font-size: 37px;
    color: #1877f2;
    line-height: 1.2em;
  }
  h3 {
    line-height: 1.2em;
    font-weight: 100;
    font-size: 25px;
    color: #808080;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 25px 0;
    position: relative;
    :after {
      content: "";
      margin-top: 20px;
      height: 1px;
      width: 50px;
      background: #888;
    }
  }
  .description {
    font-weight: 300;
    font-size: 18px;
    color: #888;
    width: 800px;
    text-align: center;
    margin: 0 auto;
    line-height: 1.2em;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .contato {
    margin-top: 50px;
    ul {
      display: flex;
      li {
        @media screen and (max-width: 768px) {
          margin: 0 20px;
        }
        margin: 0 25px;
        display: flex;
        svg {
          fill: #1877f2;
          height: 50px;
          width: 50px;
          @media screen and (max-width: 768px) {
            height: 40px;
            width: 40px;
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header/style.js